import styled from 'styled-components'

export const FooterBar = styled.footer`
  background-color: rgb(104, 157, 165);
  color: #ffffff;
  padding: 10px 20px;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;

  a {
    color: #ffffff;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: color 0.2s;

    &:hover {
      color: #c1dee3;
    }
  }

  @media (max-width: 480px) {
    flex-direction: column;
    text-align: center;
  }
`
